module.exports = __webpack_public_path__ + "static/media/Empty-guest-reservation-logo.358c18ff.svg";